<template>
  <div class="camera-container">
    <h2>姓名：{{ cameraConfig.name }}</h2>

    <!-- 加载提示 -->
    <div
      v-if="isCameraLoading"
      class="camera-loading"
      :style="{ height: `${videoHeight}px` }"
    >
      正在启动摄像头，请稍候...
    </div>

    <!-- 视频：用 v-show，不销毁 -->
    <video
      ref="videoRef"
      v-show="!photoSrc && !isCameraLoading"
      autoplay
      playsinline
      muted
      class="camera-preview"
      :style="{ height: `${videoHeight}px`, objectFit: 'cover' }"
    ></video>

    <!-- 拍照结果 -->
    <img
      v-if="photoSrc"
      :src="photoSrc"
      alt="拍摄结果"
      class="camera-preview"
      :style="{ height: `${videoHeight}px`, objectFit: 'cover' }"
    />

    <div class="btn-group" v-if="!isCameraLoading">
      <div v-if="!photoSrc">
        <button @click="takePhoto" class="btn take-btn">拍照</button>
        <button
          v-if="showSwitchCamera"
          @click="switchCamera"
          class="btn switch-btn"
        >
          切换{{ currentFacing === 'environment' ? '前置' : '后置' }}
        </button>
      </div>
      <div v-else>
        <button @click="resetCamera" class="btn reset-btn">重新拍照</button>
        <button @click="uploadToServer" class="btn submit-btn">上传照片</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps } from 'vue'
import { ElLoading } from "element-plus";
import uploadApi from "@/api/upload";

const props = defineProps({
  videoHeight: { type: Number, default: 500 },
  showSwitchCamera: { type: Boolean, default: false },
  cameraConfig: { type: Object, default: () => ({}) }
})

const videoRef = ref(null)
const photoSrc = ref('')
const fileObj = ref(null)
let mediaStream = null
const currentFacing = ref('environment')
const isCameraLoading = ref(false)

// 核心修复：打开摄像头
const openCamera = async () => {
  closeCamera()
  isCameraLoading.value = true

  // 兜底：3秒后强制关闭loading，防止卡死
  const loadingTimeout = setTimeout(() => {
    isCameraLoading.value = false
  }, 3000)

  try {
    mediaStream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: currentFacing.value,
        width: 1280,
        height: 720
      }
    })

    if (videoRef.value) {
      videoRef.value.srcObject = mediaStream
      // 用 onplay 更可靠
      videoRef.value.onplay = () => {
        clearTimeout(loadingTimeout)
        isCameraLoading.value = false
      }
    }
  } catch (err) {
    console.error('摄像头错误：', err)
    alert('无法访问摄像头，请检查权限或设备')
  } finally {
    // 无论成功失败，最终都要关loading
    clearTimeout(loadingTimeout)
    isCameraLoading.value = false
  }
}

const switchCamera = () => {
  currentFacing.value = currentFacing.value === 'environment' ? 'user' : 'environment'
  openCamera()
}

const takePhoto = () => {
  if (!videoRef.value) return
  const canvas = document.createElement('canvas')
  canvas.width = videoRef.value.videoWidth
  canvas.height = videoRef.value.videoHeight
  const ctx = canvas.getContext('2d')
  ctx.drawImage(videoRef.value, 0, 0, canvas.width, canvas.height)

  photoSrc.value = canvas.toDataURL('image/png')
  canvas.toBlob((blob) => {
    fileObj.value = new File([blob], 'photo.png', { type: 'image/png' })
  }, 'image/png')

//   closeCamera()
}

const resetCamera = () => {
  photoSrc.value = ''
  fileObj.value = null
//   openCamera()
}

const closeCamera = () => {
  if (mediaStream) {
    mediaStream.getTracks().forEach(track => track.stop())
    mediaStream = null
  }
}
const emit = defineEmits(['uploadSuccess'])
const uploadToServer = () => {
  if (!fileObj.value) return alert('请先拍照')
  const formData = new FormData()
  formData.append('file', fileObj.value)
  formData.append("FaceEngineType", 1)
  formData.append("TesterId", props.cameraConfig.id)

  const loading = ElLoading.service({
    lock: true,
    text: "上传中...",
    background: "rgba(0, 0, 0, 0.5)",
  })

  uploadApi.personnelUploadFile(formData).then((res)=>{
         console.log(res)
         loading.close();
         ElMessage({
            message: '上传成功',
            type: 'success',
            offset:200,
         })
         emit('uploadSuccess', true)
  }).catch(() => {
        loading.close();
  })
}

onMounted(() => openCamera())
onUnmounted(() => closeCamera())
</script>

<style scoped>
.camera-container {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
.camera-loading {
  width: 100%;
  border-radius: 8px;
  background: #222;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}
.camera-preview {
  width: 100%;
  border-radius: 8px;
  background: #000;
  margin: 10px 0;
}
.btn-group {
  margin-top: 15px;
}
.btn {
  padding: 10px 22px;
  font-size: 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 0 6px;
}
.take-btn { background: #409eff; color: #fff; }
.switch-btn { background: #909399; color: #fff; }
.reset-btn { background: #f56c6c; color: #fff; }
.submit-btn { background: #e6a23c; color: #fff; }
</style>